export default "__VITE_ASSET__BzODVV2t__"